import styled from "@emotion/styled";

export const SelectItem = styled.div`
  display: flex;
  padding: 10px 15px 10px 10px;
  flex-direction: row;
  justify-content: space-between;

  &:hover {
    background-color: ${({ theme }) => theme.colors.selectItemHoverBg[0]};
    cursor: pointer;
  }
`;
